<template>
    <div>
        <div class="content">
            <div class="row mt-5">
                <div class="col-md-12">
                    <h3>CONSOMMATION WEEDO TRUST</h3>
                    <div class="card">
                        <div class="card-body">
                            <div class="col-md-12">
                                <div class="row">
                                    <div
                                        class="col-xl-10 col-lg-12 col-12 order-xl-1 order-1"
                                    >
                                        <div class="row">
                                            <!-- Date de début -->
                                            <base-input
                                                class="col-md-4 mb-2"
                                                label="Date de début"
                                            >
                                                <el-date-picker
                                                    v-model="selectedStartDate"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="DATE"
                                                    :picker-options="
                                                        pickerOptions
                                                    "
                                                ></el-date-picker>
                                            </base-input>

                                            <!-- Date de fin -->
                                            <base-input
                                                class="col-md-4 mb-2"
                                                label="Date de Fin"
                                            >
                                                <el-date-picker
                                                    v-model="selectedEndDate"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="DATE"
                                                    :picker-options="
                                                        pickerOptions
                                                    "
                                                ></el-date-picker>
                                            </base-input>
                                        </div>
                                    </div>
                                    <div
                                        class="col-xl-2 col-lg-12 col-12 order-xl-2 order-3"
                                    >
                                        <div class="row">
                                                <base-button
                                                    v-if="isLoadingData"
                                                    loading
                                                    class="btn btn-just-icon btn-default mt-4 d-block"
                                                    >{{
                                                        $t(
                                                            "buttons.BtnLoad"
                                                        ).toUpperCase()
                                                    }}...</base-button
                                                >
                                                <button
                                                    v-else
                                                    class="btn btn-just-icon btn-default mt-4 d-block"
                                                    @click="getData()"
                                                >
                                                    {{
                                                        $t(
                                                            "buttons.BtnSearch"
                                                        ).toUpperCase()
                                                    }}
                                                </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="card card-chart p-3" style="min-height: 600px"> -->
                    <div class="card card-chart p-3">
                        <div class="card p-3 mb-3">
                            <div class="d-flex flex-wrap justify-content-center">
                                <div v-if="barChart3.chartData && barChart3.chartData.datasets"
                                    class="d-flex flex-wrap justify-content-center">
                                    <div v-for="(dataset, index) in barChart3.chartData.datasets"
                                        :key="index"
                                        class="d-flex align-items-center mx-3 mb-2">
                                        <span class="d-inline-block"
                                            :style="{
                                                width: '20px',
                                                height: '3px',
                                                backgroundColor: dataset.borderColor,
                                                marginRight: '8px'
                                            }">
                                        </span>
                                        <span class="text-light">
                                            {{ dataset.label }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="row"
                        >
                            <div class="col-12 col-lg-9 col-md-8" v-if="barChart3.chartData">
                                <div class="card-body">
                                    <bar-chart
                                        style="height: 400px"
                                        :chart-data="barChart3.chartData"
                                        :extra-options="chartOptions1"
                                        :gradient-colors="
                                            configChart.gradientColors
                                        "
                                        :gradient-stops="
                                            configChart.gradientStops
                                        "
                                    >
                                    </bar-chart>
                                </div>
                            </div>
                            <!-- graphe pour mg e t coreg -->
                            <div class="col-12 col-lg-3 col-md-4" v-if="barChartMgCOREG.chartData">
                                <div class="card-body">
                                    <bar-chart
                                        style="height: 400px"
                                        :chart-data="barChartMgCOREG.chartData"
                                        :extra-options="chartOptions1"
                                        :gradient-colors="configChart.gradientColors"
                                        :gradient-stops="configChart.gradientStops"
                                    >
                                    </bar-chart>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="card-body">
                            <div
                                class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                            >
                                <div class="col-xl-1 col-6">
                                    <base-input>
                                        <el-select
                                            class="select-primary pagination-select"
                                            v-model="pagination.perPage"
                                            placeholder="Per page"
                                        >
                                            <el-option
                                                class="select-primary"
                                                v-for="item in pagination.perPageOptions"
                                                :key="item"
                                                :label="item"
                                                :value="item"
                                            >
                                            </el-option>
                                        </el-select>
                                    </base-input>
                                </div>
                                <div class="col-xl-11 col-6">
                                    <label
                                        style="
                                            margin-top: 10px;
                                            font-size: 0.75rem;
                                        "
                                        >{{
                                            $t(
                                                "labels.Datatable.NbrLinePerPage"
                                            ).toUpperCase()
                                        }}</label
                                    >
                                </div>
                            </div>
                            <el-table
                                :data="filterStats"
                                row-class-name="stats-table-rows"
                                show-summary :summary-method="getSummaries"
                            >

                                <el-table-column
                                    prop="society"
                                    label="Client"
                                    :width="190"
                                    sortable
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="total_weedocheck_cost"
                                    label="Coût Weedocheck"
                                    sortable
                                >
                                    <template slot-scope="props">
                                        {{ formatThounsends2(props.row.total_weedocheck_cost, true, 2) + " €" }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="total_trustfull_cost"
                                    label="Coût Trustfull"
                                    sortable
                                >
                                    <template slot-scope="props">
                                        {{ formatThounsends2(props.row.total_trustfull_cost, true, 2) + " €" }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="total_cost"
                                    label="Coût Total"
                                    sortable
                                >
                                    <template slot-scope="props">
                                        {{ formatThounsends2(props.row.total_cost, true, 2) + " €" }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="total_tranaction_call"
                                    label="Total Transactions"
                                    sortable
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="transaction_plateforme_count"
                                    label="Transactions Plateforme"
                                    sortable
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="transaction_api_count"
                                    label="Transactions API"
                                    sortable
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="total_call"
                                    label="Total Appels"
                                    sortable
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="total_unpaid"
                                    label="Appels Gratuits"
                                    sortable
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="total_paye"
                                    label="Appels Payants"
                                    sortable
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="cout_unitaire"
                                    label="Coût Unitaire"
                                    sortable
                                >
                                    <template slot-scope="props">
                                        {{ formatThounsends2(props.row.cout_unitaire, true, 3) + " €" }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="pourcentage_depenses"
                                    label="% Depenses"
                                    sortable
                                >
                                    <template slot-scope="props">
                                        {{ formatThounsends2(props.row.pourcentage_depenses, true, 2) + " %" }}
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                    prop="taux_utilisation"
                                    label="Taux d'utilisation (%)"
                                    sortable
                                >
                                    <template slot-scope="scope">
                                        {{ scope.row.taux_utilisation }}%
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </div>
                        <div
                            slot="footer"
                            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        >
                            <div class="">
                                <p class="card-category">
                                    {{ $t("labels.Datatable.Showing") }}
                                    {{ from + 1 }}
                                    {{ $t("labels.Datatable.to") }} {{ to }}
                                    {{ $t("labels.Datatable.of") }} {{ total }}
                                    {{ $t("labels.Datatable.entries") }}
                                </p>
                            </div>
                            <base-pagination
                                class="pagination-no-border"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="total"
                            >
                            </base-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Select, Option, DatePicker, Table, TableColumn } from "element-ui";
import { BasePagination } from "src/components";
import moment from "moment";
import BarChart from "src/components/Charts/BarChart";
import config from "@/config";
import * as chartConfigs from "@/components/Charts/config";
import LineChart from "@/components/Charts/LineChart";

export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        BasePagination,
        BarChart,
        LineChart,
    },
    data() {
        return {
            barChartMgCOREG: {
                chartData: null,
                extraOptions: {
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            pickerOptions: {
                disabledDate(time) {
                return time.getTime() > Date.now();
                }
            },
            consommation_stats:[],
            switchChart: "INTERACTION",
            switchChartInt: "GLOBAL",
            switchChartInter: "CONNEXION",
            barChart2: {
                extraOptions: {
                    ...chartConfigs.barChartOptionsGradient,
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    // padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            barChart4: {
                extraOptions: {
                    ...chartConfigs.barChartOptionsGradient,
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    // padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                    tooltips: {
                    callbacks: {
                        title: function (tooltipItem, data) {
                            // Return the month as the title
                            return data.labels[tooltipItem[0].index];
                        },
                        label: function (tooltipItem, data) {
                            const datasetLabel =
                                data.datasets[tooltipItem.datasetIndex].label ||
                                "";
                            const value = tooltipItem.yLabel.toFixed(2); // Format the value with two decimal places
                            return `${datasetLabel}: ${value} %`; // Add euro symbol
                        },
                    },
                    }
                },
                /* gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0], */
            },
            barChart1: {
                extraOptions: {
                    ...chartConfigs.barChartOptionsGradient,
                    legend: {
                        display: false,
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    // padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            configChart: {
                extraOptions: {
                    ...chartConfigs.barChartOptionsGradient,

                    hover: {
                        animationDuration: 0,
                    },
                    animation: {
                        duration: 0,
                        onComplete: function () {
                            var chartInstance = this.chart,
                                ctx = chartInstance.ctx;

                            ctx.font = Chart.helpers.fontString(
                                Chart.defaults.global.defaultFontSize,
                                Chart.defaults.global.defaultFontStyle,
                                Chart.defaults.global.defaultFontFamily
                            );
                            ctx.textAlign = "center";
                            ctx.textBaseline = "bottom";
                            var gradient = ctx.createLinearGradient(
                                0,
                                0,
                                chartInstance.width,
                                0
                            );
                            gradient.addColorStop("0.5", "grey");
                            ctx.fillStyle = gradient;
                            this.data.datasets.forEach(function (dataset, i) {
                                var meta =
                                    chartInstance.controller.getDatasetMeta(i);
                                if (screen.width > 550)
                                    meta.data.forEach(function (bar, index) {
                                        var data =
                                            dataset.data[
                                                index
                                            ].toLocaleString();
                                        ctx.fillText(
                                            data,
                                            bar._model.x,
                                            bar._model.y - 3
                                        );
                                    });
                            });
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    // padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            chartOptions1: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                suggestedMin: 0,
                                suggestedMax: 1,
                                padding: 30,
                                fontColor: "#9e9e9e",
                                callback: function (value) {
                                    return value;
                                },
                            },
                        },
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                drawBorder: false,
                                color: "rgba(253,93,147,0.1)",
                                zeroLineColor: "transparent",
                            },
                            ticks: {
                                // padding: 20,
                                fontColor: "#9e9e9e",
                            },
                        },
                    ],
                },
                /* tooltips: {
                    callbacks: {
                        title: function (tooltipItem, data) {
                            // Return the month as the title
                            return data.labels[tooltipItem[0].index];
                        },
                        label: function (tooltipItem, data) {
                            const datasetLabel =
                                data.datasets[tooltipItem.datasetIndex].label ||
                                "";
                            const value = tooltipItem.yLabel.toFixed(2); // Format the value with two decimal places
                            return datasetLabel == "LTV/CAC"
                                ? `${datasetLabel}: ${value} `
                                : `${datasetLabel}: ${value} €`; // Add euro symbol
                        },
                    },
                }, */
            },
            barChart3: {
                extraOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    ...chartConfigs.barChartOptionsGradient,

                    hover: {
                        animationDuration: 0,
                    },
                    animation: {
                        duration: 0,
                        onComplete: function () {
                            var chartInstance = this.chart,
                                ctx = chartInstance.ctx;

                            ctx.font = Chart.helpers.fontString(
                                Chart.defaults.global.defaultFontSize,
                                Chart.defaults.global.defaultFontStyle,
                                Chart.defaults.global.defaultFontFamily
                            );
                            ctx.textAlign = "center";
                            ctx.textBaseline = "bottom";
                            var gradient = ctx.createLinearGradient(
                                0,
                                0,
                                chartInstance.width,
                                0
                            );
                            gradient.addColorStop("0.5", "grey");
                            ctx.fillStyle = gradient;
                            this.data.datasets.forEach(function (dataset, i) {
                                var meta =
                                    chartInstance.controller.getDatasetMeta(i);
                                if (screen.width > 550)
                                    meta.data.forEach(function (bar, index) {
                                        var data =
                                            dataset.data[
                                                index
                                            ].toLocaleString();
                                        ctx.fillText(
                                            data,
                                            bar._model.x,
                                            bar._model.y - 3
                                        );
                                    });
                            });
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                            position: "top",
                            align: "start",
                            labels: {
                                boxWidth: 40,
                                usePointStyle: false,
                                pointStyle: "line",
                                padding: 20,
                                color: "#9e9e9e",
                                generateLabels: function (chart) {
                                    const datasets = chart.data.datasets;
                                    return datasets.map((dataset) => ({
                                        text: dataset.label,
                                        fillStyle: "transparent",
                                        strokeStyle: dataset.borderColor,
                                        lineWidth: 2,
                                        hidden: false,
                                        lineDash: dataset.borderDash || [],
                                    }));
                                },
                            },
                        },
                    },
                    scales: {
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 0,
                                    suggestedMax: 1,
                                    padding: 30,
                                    fontColor: "#9e9e9e",
                                    callback: function (value) {
                                        return value;
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                gridLines: {
                                    drawBorder: false,
                                    color: "rgba(253,93,147,0.1)",
                                    zeroLineColor: "transparent",
                                },
                                ticks: {
                                    // padding: 20,
                                    fontColor: "#9e9e9e",
                                },
                            },
                        ],
                    },
                },
                gradientColors: config.colors.MyAfillGradient,
                gradientStops: [1, 0],
            },
            isLoadingData: false,
            selectedStartDate: null,
            selectedEndDate: null,
            startDate: null, //moment().startOf('month').format('YYYY-MM-DD'),
            endDate: null, //moment().format('YYYY-MM-DD'),
            daily_stats: [],
            accessToken: localStorage.getItem("token_jwt"),
            selectedDate: "",
            statsData: [
                {
                    date: "2025-01-29",
                    connections: 15,
                    queries: 120,
                    quota: 200,
                    premiumData: 80,
                    riskData: 30,
                    standardData: 10,
                    creditUsage: 40,
                },
                {
                    date: "2025-01-30",
                    connections: 22,
                    queries: 140,
                    quota: 200,
                    premiumData: 90,
                    riskData: 40,
                    standardData: 10,
                    creditUsage: 45,
                },
                {
                    date: "2025-01-31",
                    connections: 30,
                    queries: 160,
                    quota: 200,
                    premiumData: 100,
                    riskData: 50,
                    standardData: 10,
                    creditUsage: 50,
                },
                {
                    date: "2025-02-01",
                    connections: 25,
                    queries: 180,
                    quota: 200,
                    premiumData: 120,
                    riskData: 30,
                    standardData: 30,
                    creditUsage: 55,
                },
                {
                    date: "2025-02-02",
                    connections: 27,
                    queries: 200,
                    quota: 200,
                    premiumData: 140,
                    riskData: 40,
                    standardData: 20,
                    creditUsage: 60,
                },
            ],
            pagination: {
                perPage: 50,
                currentPage: 1,
                perPageOptions: [50, 100, 200],
                total: 0,
            },
        };
    },
    computed: {
        filterStats() {
            let result = this.consommation_stats;
            return result.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.consommation_stats.length;
        },
    },
    mounted() {
        this.getData();
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];

            // Calcul des totaux à partir des données de la table
            const totals = data.reduce((acc, row) => ({
                total_weedocheck_cost: acc.total_weedocheck_cost + (row.total_weedocheck_cost || 0),
                total_trustfull_cost: acc.total_trustfull_cost + (row.total_trustfull_cost || 0),
                total_call: acc.total_call + (Number(row.total_call) || 0),
                total_weedocheck_paied: acc.total_weedocheck_paied + (Number(row.total_weedocheck_paied) || 0),
                total_trustfull_paied: acc.total_trustfull_paied + (Number(row.total_trustfull_paied) || 0),
                total_unpaid: acc.total_unpaid + (Number(row.total_unpaid) || 0),
                total_tranaction_call: acc.total_tranaction_call + (Number(row.total_tranaction_call) || 0),
                transaction_plateforme_count: acc.transaction_plateforme_count + (Number(row.transaction_plateforme_count) || 0),
                transaction_api_count: acc.transaction_api_count + (Number(row.transaction_api_count) || 0),
                total_cost: acc.total_cost + (Number(row.total_cost) || 0),
                total_paye: acc.total_paye + (Number(row.total_paye) || 0),
            }), {
                total_weedocheck_cost: 0,
                total_trustfull_cost: 0,
                total_call: 0,
                total_weedocheck_paied: 0,
                total_trustfull_paied: 0,
                total_unpaid: 0,
                total_tranaction_call: 0,
                transaction_plateforme_count: 0,
                transaction_api_count: 0,
                total_cost: 0,
                total_paye: 0,
            });

            // Calcul de la moyenne du taux d'utilisation
            const taux_moyen = totals.total_call
                                    ? 100 - ((totals.total_unpaid * 100) / totals.total_call)
                                    : 0;
            const cout_unitaire = totals.total_tranaction_call ? (totals.total_cost) / totals.total_tranaction_call : 0

            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '';  // Colonne Date
                    return;
                }
                else if (index === 1) {
                    sums[index] = this.formatThounsends2(totals.total_weedocheck_cost, true, 2) + " €";  // Connexions
                    return;
                }
                else if (index === 2) {
                    sums[index] = this.formatThounsends2(totals.total_trustfull_cost, true, 2) + " €";   // INTERROGATIONs
                    return;
                }
                else if (index === 3) {
                    sums[index] = this.formatThounsends2(totals.total_cost, true, 2) + " €";   // INTERROGATIONs
                    return;
                }
                else if (index === 4) {
                    sums[index] = totals.total_tranaction_call;  // Données Premiums
                    return;
                }
                else if (index === 5) {
                    sums[index] = totals.transaction_plateforme_count;  // Données Premiums
                    return;
                }
                else if (index === 6) {
                    sums[index] = totals.transaction_api_count;  // Données Premiums
                    return;
                }
                else if (index === 7) {
                    sums[index] = totals.total_call;  // Données Premiums
                    return;
                }
                else if (index === 8) {
                    sums[index] = totals.total_unpaid;  // Données Premiums
                    return;
                }
                else if (index === 9) {
                    sums[index] = totals.total_paye;  // Données Premiums
                    return;
                }
                else if (index === 10) {
                    sums[index] = this.formatThounsends2(cout_unitaire, true, 3) + " €";  // Taux d'utilisation
                    return;
                }
                else if (index === 11) {
                    sums[index] = this.formatThounsends2(taux_moyen, true, 2) + '%';  // Taux d'utilisation
                    return;
                }
                else {
                    sums[index] = '';
                    return;
                }
            });

            return sums;
        },
        formatThounsends2: function (value, fixe = false, number = 0) {
            let prix = Number(value)
            if (prix) {
                prix = prix.toFixed(number);
            }else{
                prix = 0
            }
            return prix.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        createMultipleChart(labels, datasets) {
            return {
                labels,
                datasets: datasets.map((dataset) => ({
                    type: "line",
                    label: dataset.label,
                    fill: false,
                    //borderColor: config.colors.myAfill,
                    borderColor: dataset.borderColor,
                    borderWidth: 2,
                    borderDash: [],
                    data: dataset.data,
                })),
            };
        },
        getData() {
            this.consommation_stats = [];
            this.isLoadingData = true;
            this.axios
                .get(
                    "https://api-auth-plf.wee-do-it.net/api/v1/trust/cost_stats",
                    {
                        params: {
                            start_date: this.selectedStartDate, // format YYYY-MM-DD
                            end_date: this.selectedEndDate, // format YYYY-MM-DD
                        },
                        headers: {
                            authorization: `Bearer ${this.accessToken}`,
                        },
                    }
                )
                .then((response) => {
                     if (response.data && response.data.data){
                        let data = response.data.data
                        let totals = []

                    // Parcourt chaque nom dans les données reçues
                        for (let name in data) {
                            /* let totalWeedoCheckCost = data[name].users.reduce((sum, user) => {
                                                    return sum + user.weedocheck.cost;
                                                }, 0);
                            let totalTrustfullCost = data[name].users.reduce((sum, user) => {
                                                    return sum + user.trustfull.cost;
                                                }, 0); */
                            let total_weedocheck_paied = data[name].users[0].weedocheck.paid_usage
                            let cost_weedo_check = data[name].users[0].weedocheck.cost
                            let total_trustfull_paied = data[name].users[0].trustfull.paid_usage
                            let cost_trustfull = data[name].users[0].trustfull.cost
                            let total_tranaction_call = data[name].society_total.total_transactions
                            let transaction_plateforme_count = data[name].society_total.transaction_plateforme_count
                            let transaction_api_count = data[name].society_total.transaction_api_count
                            let total_call = data[name].society_total.total
                            let total_unpaid = data[name].society_total.total_unpaid
                            let cout_unitaire = total_tranaction_call ? (data[name].society_total.total_cost) / total_tranaction_call : 0
                            let total_cost = data[name].society_total.total_cost

                            /* let pourcentage_depenses = data[name].society_total.total
                                                            ? 100 - ((data[name].society_total.total_unpaid* 100) / data[name].society_total.total)
                                                            : 0; */
                            // de total au lieu de le fare de transactions
                            let pourcentage_depenses = total_call
                                                            ? 100 - ((data[name].society_total.total_unpaid * 100) / total_call)
                                                            : 0;

                            //For Graph
                            let total_paye =  total_call - total_unpaid

                            let total = {
                                society:name,
                                total_weedocheck_cost:cost_weedo_check,
                                total_trustfull_cost: cost_trustfull,
                                total_free: 0,
                                total_paye: total_paye,
                                total_call: total_call,
                                total_tranaction_call: total_tranaction_call,
                                transaction_plateforme_count: transaction_plateforme_count,
                                transaction_api_count: transaction_api_count,
                                pourcentage_depenses: pourcentage_depenses,
                                cout_unitaire: cout_unitaire,
                                total_weedocheck_paied: total_weedocheck_paied,
                                total_trustfull_paied: total_trustfull_paied,
                                total_unpaid: total_unpaid,
                                total_cost: total_cost,
                            }
                            totals.push(total)
                        }
                        //totals = [{name:"yes"}]
                        this.consommation_stats =totals
                        let mainClients = totals.filter(client => client.society !== 'mg' && client.society !== 'coreg' && client.society !== 'location_data');
                        let mgcoregClients = totals.filter(client => !mainClients.includes(client));

                        let data_chart = {
                            labels: mainClients.map((obj) => obj.society.toUpperCase()),
                            total_unpaid: mainClients.map((obj) => obj.total_unpaid),
                            total_paye: mainClients.map((obj) => obj.total_paye),
                            total_call: mainClients.map((obj) => obj.total_call),
                            total_tranaction_call: mainClients.map((obj) => obj.total_tranaction_call),
                        }
                        let data_chart_mgcoreg = {
                            labels: mgcoregClients.map((obj) =>  obj.society.toUpperCase()),
                            total_unpaid: mgcoregClients.map((obj) => obj.total_unpaid),
                            total_paye: mgcoregClients.map((obj) => obj.total_paye),
                            total_call: mgcoregClients.map((obj) => obj.total_call),
                            total_tranaction_call: mgcoregClients.map((obj) => obj.total_tranaction_call),
                        };

                        this.barChart3.chartData = this.createMultipleChart(
                            data_chart.labels,
                            [
                                {
                                    label: "Nombre de transactions",
                                    data: data_chart.total_tranaction_call,
                                    borderColor: "#FFC107", // Orange foncé
                                },
                                {
                                    label: "Total des Appels",
                                    data: data_chart.total_call,
                                    borderColor: "#0D6EFD", // Bleu foncé
                                },
                                {
                                    label: "Nombre d'appels gratuits",
                                    data: data_chart.total_unpaid,
                                    borderColor: "#198754", // Vert foncé
                                },
                                {
                                    label: "Nombre d'appels payants",
                                    data: data_chart.total_paye,
                                    borderColor: "#C82333", // Rouge profond
                                },
                            ]
                        );
                        this.barChartMgCOREG.chartData = this.createMultipleChart(
                            data_chart_mgcoreg.labels,
                            [
                                {
                                    label: "Nombre de transactions",
                                    data: data_chart_mgcoreg.total_tranaction_call,
                                    borderColor: "#FFC107", // Orange foncé
                                },
                                {
                                    label: "Total des Appels",
                                    data: data_chart_mgcoreg.total_call,
                                    borderColor: "#0D6EFD", // Bleu foncé
                                },
                                {
                                    label: "Nombre d'appels gratuits",
                                    data: data_chart_mgcoreg.total_unpaid,
                                    borderColor: "#198754", // Vert foncé
                                },
                                {
                                    label: "Nombre d'appels payants",
                                    data: data_chart_mgcoreg.total_paye,
                                    borderColor: "#C82333", // Rouge profond
                                },
                            ]
                        );
                     }

                })
                .catch((error) => {
                    console.error(error);
                    this.barChart3.chartData = this.createMultipleChart(
                        [],
                        [
                            {
                                label: "Nombre de transactions",
                                data: [],
                                borderColor: "#FFC107",
                            },
                            {
                                label: "Total des Appels",
                                data: [],
                                borderColor: "#0D6EFD",
                            },
                            {
                                label: "Nombre d'appels gratuits",
                                data: [],
                                borderColor: "#198754",
                            },
                            {
                                label: "Nombre d'appels payants",
                                data: [],
                                borderColor: "#C82333",
                            },
                        ]
                    );
                    this.barChartMgCOREG.chartData = this.createMultipleChart(
                        [],
                        [
                            {
                                label: "Nombre de transactions",
                                data: [],
                                borderColor: "#FFC107",
                            },
                            {
                                label: "Total des Appels",
                                data: [],
                                borderColor: "#0D6EFD",
                            },
                            {
                                label: "Nombre d'appels gratuits",
                                data: [],
                                borderColor: "#198754",
                            },
                            {
                                label: "Nombre d'appels payants",
                                data: [],
                                borderColor: "#C82333",
                            },
                        ]
                    );
                })
                .finally(() => {
                    this.isLoadingData = false;
                });
        },
        reset() {
            this.selectedDate = "";
        },
    },
};
</script>

<style>
.stats-table-rows {
    text-transform: uppercase;
}

.chart-container {
    height: 400px; /* ou la hauteur souhaitée */
    position: relative;
}
.hidden {
    display: NONE;
}
</style>
